import { render, staticRenderFns } from "./EditRiskViewpoint.vue?vue&type=template&id=149df868&scoped=true"
import script from "./EditRiskViewpoint.vue?vue&type=script&lang=js"
export * from "./EditRiskViewpoint.vue?vue&type=script&lang=js"
import style0 from "./EditRiskViewpoint.vue?vue&type=style&index=0&id=149df868&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149df868",
  null
  
)

export default component.exports